import type { FaireProductEntity } from "../../entity_types/product";

export const p_b256rebj: FaireProductEntity = {
  token: "p_b256rebj",
  type: "product",
  name: "I Love You Mom Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/fab65d14a86c3d9d1b931561d85271ccc2da4e0e0a90eab9a8e9a895d5e58338.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/722481970a5d410981a55ee2aded1b10f89c4b74ec03d47d320ee13c220aca75/1528387602.png",
    "https://cdn.faire.com/fastly/f92e3394d2b3d52a104164a9b4db9ab88e8ed506ca7e528727fab87440e35c6b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:06.596Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
